import { AttributeFieldSchema } from 'models/AttributeField';
import z from 'zod';

export const AttributeListResultSchema = z.object({
    data: z.array(AttributeFieldSchema),
    total: z.number(),
});

export type AttributeListResult = z.infer<typeof AttributeListResultSchema>;
